import { render, staticRenderFns } from "./PuiApprove.vue?vue&type=template&id=e7a35856"
import script from "./PuiApprove.vue?vue&type=script&lang=js"
export * from "./PuiApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports